import { render } from "./EmbeddedMethodsList.vue?vue&type=template&id=3d0bb64f&lang=pug"
import script from "./EmbeddedMethodsList.vue?vue&type=script&lang=js"
export * from "./EmbeddedMethodsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__